<template>
  <div class="scroll-wrapper" v-if="loading">
    <!-- 展示训练营二维码 -->
    <div class="top-bar" :class="{'bar-holder': isWpsIos||isWpsAndroid||isLoan}" v-if="courseInfo.qrcode && !isLoan" @click="handlerClick()">
      <div class="top-bar-desc">
        <img src="../../assets/icons/icon-service.png" alt="">
        <span>线上报班课程详情咨询</span>
      </div>
      <div class="top-bar-btn">
        微信咨询
      </div>
    </div>

    <div class="sign-up" ref="page">
      <!-- 知识合伙人角标 -->
      <div v-if="Number(courseInfo.earnMoney)" class="distributionFlag" @click="toMakePoster">
        <img src="../../assets/images/sign-up-corner-flag.png" alt="flag"/>
        <span>赚{{ courseInfo.earnMoney }}</span>
      </div>
      <!-- 试看视频 -->
      <try-video
        v-if="!hasBuy"
        :isTryVideoShow="courseInfo.courseType === 8 ? true : isTryVideoShow"
        :url="courseInfo.courseType === 8 ? 'AI课' : tryInfo.videoUrl"
        :image="tryInfo.image"
        :courseType="courseInfo.courseType"
         />

      <!-- 非试看视频时显示 -->
      <!-- 因调整页面布局以处理 ios 滑动的问题，将 .sign-up 进行了 100% 高度处理，
           因此这里图片不能再继承父元素高度，因此加了一个 img-f-w 以适应当前情况 -->
      <!-- <div class="sign-up-tryImage" v-if="!tryInfo.videoUrl &&! hasBuy">
        <img :src="tryInfo.image" alt="" class="img-f-w">
      </div> -->
      <!-- 课程类型 -->
      <course-type-bar :courseDeadline="courseInfo.validDays" :courseType="courseInfo.courseType" :learningCount="courseInfo.learningCount" v-if="tryInfo.image && !hasBuy"></course-type-bar>

      <!-- 试看音频 图片不再在内显示-->
      <try-audio
        v-if="!hasBuy"
        :url="tryInfo.audioUrl"
        :title="tryInfo.title"
        :length="tryInfo.audioLength"
        :image="tryInfo.image" />
      <!-- 已购买, 立即学习 -->
      <sign-up-study
        v-if="hasBuy && tryInfo.image"
        :image="tryInfo.image"
        @click="learn" />

      <!-- 拼团规则 -->
      <sign-up-group-rule
        v-if="groupRuleShow"
        :groupDuration="courseInfo.groupDuration"
        :groupEndDate="courseInfo.groupEndDate"
        :groupSuccessCount="courseInfo.groupSuccessCount"/>
      <!-- 拼团 -->
      <sign-up-group
        v-if="groupShow"
        :groupLength="groupLength"
        :groupLists="groupLists"
        @buyGroup="buyGroup"/>

      <ui-tab
        :list="tabs"
        :index="tabIndex"
        @change="tab" />

      <div v-if="tabIndex === 0" style="min-height:500px">
        <img
          class="img-w"
          v-for="(item, index) in images"
          :key="index"
          :src="item"
        />
        <dl class="sign-up-desc">
          <dt>购买须知</dt>
          <dd>本课程为付费课程，购买成功后，即可永久学习！</dd>
          <dd>由于课程为虚拟内容产品，一经购买概不退款，请您理解！</dd>
          <dd>如果您在购买课程和使用课程的过程遇到了问题，请关注微信公众号：{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '微课系统'}}。</dd>
          <!-- <dd>听课平台：{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '微课系统'}}公众号内，点击课程推送消息即可听课</dd> -->
        </dl>
      </div>

      <schedule-list
        v-if="isScheduleVisible"
        page="sign-up"
        :dataSource="schedules"
        :has-buy="hasBuy"
        :ai-course="courseInfo.courseType"
        @fold="handleFoldSection"
      />
    </div>

    <!-- 底部按钮 -->
    <sign-up-bottom
      v-if="courseInfo.status !== 3"
      :hasBuy="hasBuy"
      :marketPrice="priceInfo.marketPrice"
      :vipDiscount="priceInfo.vipDiscount"
      :vipPrice="priceInfo.vipPrice"
      :price="priceInfo.price"
      :priceDel="priceInfo.origin"
      :activityPrice="priceInfo.activityPrice"
      :isInAct="priceInfo.isInAct"
      :is-ios="isWpsIos"
      :is-android="isWpsAndroid"
      :isVip="isVip"
      :isGroupCourse="courseInfo.isGroupCourse"
      :groupPrice="courseInfo.groupPrice"
      :groupId="courseInfo.groupId"
      :groupStatus="courseInfo.groupStatus"
      :pingAble="pingAble"
      :totalEndTime.sync="totalEndTime"
      :biggestCoupon="biggestCoupon"
      :vipExclusiveFlag="courseInfo.vipExclusiveFlag"
      :effectivePrice="effectivePrice"
      :effectiveVipPrice="effectiveVipPrice"
      :signInfo="signInfo"
      @share="share"
      @sign="sign"
      @learn="learn"
      @buy="buy"
      @send="send"
      @joinWPSVip="joinWPSVip"
      @buyGroup="buyGroup"
    />

    <sign-up-coupon
      @buy="buy"
      @send="send"
    />

    <!-- 训练营二维码浮层 -->
    <Notice v-if="courseInfo.qrcode" ref="notice" :closeBtn="true" @closeBubble="closeBubble">
      <div class="notice-main">
        <h1>扫描二维码添加课程助手</h1>
        <img :src="courseInfo.qrcode" alt="">
        <p>长按或保存图片识别二维码</p>
      </div>
    </Notice>

    <!-- 购买挽留浮层 -->
    <RetainBubble
      ref="retain"
      :price="realityPrice"
      :isRetain="isRetain"
    />

    <!-- 二维码 ?action=bothCode -->
    <Notice v-if="$route.query.action === 'bothCode'" ref="noticeBothCode" :closeBtn="true" >
      <div class="notice-main">
        <h1>距离“0元领取36本书”还差一步</h1>
        <img src="https://cdn.iciba.com/www/edu-m-2.0/bothCode.jpg" alt="" />
        <p>长按识别二维码，关注后立即领取！</p>
      </div>
    </Notice>

    <!-- 优惠券 ?action=coupon100 -->
    <Notice ref="noticeCoupon100" closeBtn transparent>
      <div class="notice-main" @click="buy">
        <img src="https://cdn.iciba.com/www/edu-m-2.0/coupon100.png" alt="" />
      </div>
    </Notice>
  </div>
</template>

<script>
  import Index from './index'
  export default Index
</script>

<style lang="scss">
  @import "./style";
</style>
